import { SetStateAction, useCallback, useEffect, useState } from 'react'
import {
  ClusterPayload,
  ValidationResultInterface,
  ValidationRulesInterface,
} from '../../../../../../../../../common/types/interfaces'
import { delayAction } from '../../../../../../../../../common/utils/functions/delayAction'
import { getApi } from '../../../../../../../../../api/api'
import { useValidation } from '../../../../../../../../../common/hooks/useValidation'
import { useInput } from '../../../../../../../../../common/hooks/useInput'
import {
  clusterValidations,
  schedulePattern,
} from '../../../../../../../../../common/utils/constants'

const initialValue: ClusterPayload = {
  name: 'Первый кластер',
  description: 'Сгенерирован автоматически при настройке',
  phone_number: '', // 👈 добавить
  disabledTemporary: false,
  withDelivery: false,
  withBonuses: false,
  schedule: [...schedulePattern],
  type: '',
  delivery: [],
  bonuses: [],
  legalName: '',
  legalInn: '',
  legalAddress: '',
  legalEntityType: '',

  regularSales: true,
  complexSales: false,
  showRating: true,
  manageStock: false,
  showOutOfStock: false,
}

const validations: ValidationRulesInterface[] = clusterValidations

export const useForm = (
  getClusters: () => void,
  setModalActive: React.Dispatch<SetStateAction<boolean>>,
  setLoading: React.Dispatch<SetStateAction<boolean>>,
  loading: boolean,
) => {
  const [message, setMessage] = useState<string>('')
  const [data, setData] = useState<ClusterPayload>({ ...initialValue })
  const [api] = useState(getApi())
  const [validationResult, setValidationResult] = useState<ValidationResultInterface[] | []>([])
  const [disabled, setDisabled] = useState<boolean>(true)
  const { validate, checkAndAddValidation, setDirty } = useValidation(
    setValidationResult,
    validationResult,
    validations,
  )
  const { inputHandler } = useInput(setData)

  const getValidationResult = (fieldName: string) => {
    return validationResult.find((el) => el.name === fieldName)
  }

  const toggleAction = useCallback(
    (fieldName: string) => {
      setData((prev) => {
        return { ...prev, [fieldName]: !prev[fieldName] }
      })
    },
    [setData],
  )

  const generateCluster = useCallback(async () => {
    try {
      setMessage('идет генерация пожалуйста подождите...')
      setLoading(true)
      await delayAction(2000)
      await api.createCluster({
        ...data,
      })
      await getClusters()
      setMessage(
        'генерация выполнена успешно, дождитесь активации кластера, если вы не заключали договор, свяжитесь с поддержкой',
      )
      await delayAction(1000)
      setModalActive(false)
    } catch (error) {
      setMessage('генерация не прошла, повторите попытку позже, или обратитесть в поддержку')
      await delayAction(2000)
      setLoading(false)
      setModalActive(false)
    }
  }, [api, getClusters, data, setModalActive, setLoading])

  useEffect(() => {
    for (var item in data) {
      if (validations.map((el) => el.fieldName).includes(item)) {
        checkAndAddValidation(item)
      }
    }
  }, [checkAndAddValidation, data])

  useEffect(() => {
    for (var item in data) {
      if (validations.map((el) => el.fieldName).includes(item)) {
        validate(item, data[item])
      }
    }
  }, [data])

  useEffect(() => {
    setDisabled(Boolean(validationResult.find((el) => el.notValid)))
  }, [validationResult])

  return {
    generateCluster,
    message,
    data,
    setDirty,
    inputHandler,
    toggleAction,
    setData,
    getValidationResult,
    disabled,
  }
}
